module.exports = __webpack_public_path__ + "static/media/menu.1a40ee5c.svg";